import { render, staticRenderFns } from "./LogsActividad.vue?vue&type=template&id=0b5e1ce8&"
import script from "./LogsActividad.vue?vue&type=script&lang=js&"
export * from "./LogsActividad.vue?vue&type=script&lang=js&"
import style0 from "./LogsActividad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0b5e1ce8', component.options)
    } else {
      api.reload('0b5e1ce8', component.options)
    }
    module.hot.accept("./LogsActividad.vue?vue&type=template&id=0b5e1ce8&", function () {
      api.rerender('0b5e1ce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/SystemManagement/logs-management/LogsActividad.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/SystemManagement/logs-management/LogsActividad.vue
// module id = rLD4
// module chunks = 0